import React, { useContext, useState } from 'react';
import firebase from "../config/firebase";
import CssBaseline from '@material-ui/core/CssBaseline';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';
import { makeStyles , useTheme} from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import CircularProgress from '@material-ui/core/CircularProgress';
import { Divider, Container, Grid, Drawer  } from '@material-ui/core';

import { AuthContext } from '../Auth.js'

import SidebarNav from './Sidebar.js';


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
    flexGrow: 1,
    margin:theme.spacing(0),
    padding:theme.spacing(0),
    },
    title: {
    flexGrow: 1,
    textAlign:'left'
    }, 
    imgLogo: {
      width: "50px",
      marginRight: theme.spacing(1)
    },
    button: {
        margin: theme.spacing(1),
        float: 'right'
    },
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginRight: drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(0),
      paddingLeft: theme.spacing(2),
      marginTop: theme.spacing(1),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: 0,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    nav: {
      marginBottom: theme.spacing(2)
    }
 }));





function Volunteer (props) {
    
    const classes = useStyles();
    const theme = useTheme();

    const [open, setOpen] = useState(false);
    const {currentUser,userProfile, setUserProfile } = useContext(AuthContext);

    const handleDrawerOpen = () => {
      setOpen(true);
    };
  
    const handleDrawerClose = () => {
      setOpen(false);
    };

    const GetBase = () => {
    
      return (
      <>
        <CssBaseline />
        <AppBar position="sticky" color="default" 
          className={clsx(classes.appBar, {[classes.appBarShift]: open, })}
        >
        <Toolbar id="back-to-top-anchor" >
          <img alt="Unidos Para Ayudar" className={classes.imgLogo} src={require('../assets/img/logo.png')} />
          <Typography className={classes.title} variant="h6">Unidos Para Ayudar</Typography>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
        </AppBar>
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="right"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.drawerHeader}>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'ltr' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>
          <Divider />
          <SidebarNav 
          className={classes.nav} 
          />
        </Drawer>
      </>
      );
    };
      
    if (!userProfile) {
      return (
        <div className={classes.root}>
          { GetBase() }
          <main
            className={clsx(classes.content, {
              [classes.contentShift]: open,
            })}
          >
          <div className={classes.drawerHeader} />
          <br></br>
          <Container spacing={2}>
          <CircularProgress />
          </Container>
          </main>
        </div>
      )
    } 

    const handleUpdate = (event) =>  {
      event.preventDefault();
      const { phoneNumber, firstName, lastName, cedula } = event.target.elements;
      try {
        firebase.firestore().collection('orgs').doc('unidos')
            .collection('users')
            .doc(currentUser.uid)
            .update({
              "nombre"   : firstName.value.toUpperCase(),
              "apellido" : lastName.value.toUpperCase(),
              "celular"  : phoneNumber.value ,
              "cedula"   : cedula.value
            });
            setUserProfile({
              ...userProfile,
              nombre   : firstName.value.toUpperCase(),
              apellido : lastName.value.toUpperCase(),
              celular  : phoneNumber.value,
              cedula   : cedula.value
            })
        } catch (error) {
          alert(error);
        }
    };

    const mostrarAccionCovid = () => {
      return (
        <></>
      );
    }


    return (
        <div className={classes.root}>
        { GetBase() }
        <main
              className={clsx(classes.content, {
                [classes.contentShift]: open,
              })}
          >
        <Typography component="h1" variant="h5">
          Información de Voluntario
        </Typography>
        <br></br>
        { mostrarAccionCovid() }
        <br></br>
        <Typography component="h3" variant="h6">
          Actualizar datos
        </Typography>
        <br></br>
        <form className={classes.form} noValidate onSubmit={handleUpdate}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoComplete="fname"
                name="firstName"
                variant="outlined"
                required
                id="firstName"
                defaultValue={userProfile.nombre}
                label="Nombre"
                autoFocus
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                id="lastName"
                label="Apellido"
                name="lastName"
                defaultValue={userProfile.apellido}
                autoComplete="lname"
              />
            </Grid>
            <Grid item xs={12}>
            <TextField
                variant="outlined"
                required
                id="cedula"
                label="Cedula"
                name="cedula"
                defaultValue={userProfile.cedula}
                autoComplete="cedula"
              />
            </Grid>
            <Grid item xs={12}>
            <TextField
                variant="outlined"
                required
                id="phoneNumber"
                label="Celular"
                name="phoneNumber"
                defaultValue={userProfile.celular}
                autoComplete="phone"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.submit}
              >
              Actualizar
            </Button>
            </Grid>
          </Grid>
        </form>      
        </main> 
        </div>
    );

}

export default Volunteer;